import { createContext, ReactNode } from "react";

export class Other {
    public name?:string;
    age?:number;
    constructor(name:string,age:number) {
        this.name = name;
        this.age = age;
    }
    public getInfo = ()=>{
        return `name:${this.name},age:${this.age}`;
    };
}
export interface OtherProviderProps {
    children?: ReactNode;
}
export const OtherContext = createContext({} as Other);
const other = new Other('xx',20);
export const OtherProvider = (props:OtherProviderProps) => {

    return <OtherContext.Provider value={other}>
        {props.children}
    </OtherContext.Provider>

}